<template>
  <form v-on:submit.prevent>
    <div class="quantity">
      <span>Quantity:</span>
      <div class="input-counter">
        <span @click="handleDecrementClick" class="minus-btn">
          -
        </span>
        {{ itemNumber }}
        <span @click="handleIncrementClick" class="plus-btn">
          +
        </span>
      </div>
    </div>

    <button class="btn btn-primary" @click="handleAddToCartClick">
      Add to Cart
    </button>
    &nbsp;

    <b-icon-heart-fill v-if="onWishList" @click="handleToggleAddToWishlist" />
    <b-icon-heart v-else @click="handleToggleAddToWishlist" />
    <br />
    <br />
    <div class="buy-btn">
      <b-button class="btn btn-primary" @click="handleBuyNowClick">
        Buy it Now
      </b-button>
    </div>
  </form>
</template>

<script>
export default {
  name: "AddToCartDetails",
  props: {
    product: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      onWishList: false,
      itemNumber: 1,
      imgSrc:
        "https://media-cldnry.s-nbcnews.com/image/upload/t_fit-1240w,f_auto,q_auto:best/newscms/2019_33/2203981/171026-better-coffee-boost-se-329p.jpg"
    };
  },
  methods: {
    handleAddToCartClick() {
      this.$emit("add-to-cart", this.product);
    },
    handleToggleAddToWishlist() {
      this.onWishList = !this.onWishList;
      if (this.onWishList) {
        this.$emit("add-to-wishlist", this.product);
      } else {
        this.$emit("remove-from-wishlist", this.product);
      }
    },
    handleBuyNowClick() {
      this.$emit("buy-now", this.product);
    },
    handleIncrementClick() {
      this.$emit("product-increment", this.product, this.itemNumber);
    },
    handleDecrementClick() {
      this.$emit("product-decrement", this.product, this.itemNumber);
    },
    increment() {
      if (this.itemNumber < 10) {
        this.itemNumber++;
      } else {
        this.$toasted.show("Can't add more than 10 items", {
          icons: "shopping_cart",
          theme: "bubble",
          position: "top-right",
          duration: 3000
        });
      }
    },
    decrement() {
      if (this.itemNumber > 1) {
        this.itemNumber--;
      } else {
        this.$toasted.show("Can't add less than 1 item", {
          icons: "shopping_cart",
          theme: "bubble",
          position: "top-right",
          duration: 3000
        });
      }
    },
    addToCart(item) {
      this.$toasted.show("Added to bag", {
        icons: "shopping_cart",
        theme: "bubble",
        position: "top-right",
        duration: 3000
      });
      if (this.size !== "") {
        this.$store.commit({
          type: "addToCart",
          id: item.id,
          name: item.name,
          price: item.price,
          image: item.image,
          productQuantity: this.itemNumber,
          totalPrice: item.price * this.itemNumber
        });
      }
    }
  }
};
</script>
